
import "./MemosPage.css";
import Memos from "/src/features/memos/Memos";
import { PageTable, Header } from '/src/layouts/page';

function MemosPage() {

    return (
        <PageTable>
            <Header title="List of Memos"></Header>
            <Memos/>
        </PageTable>
    )
}

export default MemosPage